import React from "react";
import { Link } from "react-router-dom";
import heroBgPattern from "../assets/hero-bg-pattern.png";
const HeroSection: React.FC = () => {
  return <div className="relative min-h-screen bg-gradient-to-br from-tagblue via-tagblue to-tagblue-dark overflow-hidden">
      {/* 3D Background Pattern */}
      <div className="absolute inset-0 opacity-20 bg-cover bg-center bg-no-repeat animate-gradient-shift" style={{
      backgroundImage: `url(${heroBgPattern})`
    }} />
      
      {/* Floating geometric shapes */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-3xl backdrop-blur-sm rotate-12 animate-float" />
        <div className="absolute top-40 right-20 w-24 h-24 bg-white/10 rounded-2xl backdrop-blur-sm -rotate-12 animate-float" style={{
        animationDelay: '2s'
      }} />
        <div className="absolute bottom-40 left-20 w-20 h-20 bg-white/10 rounded-xl backdrop-blur-sm rotate-45 animate-float" style={{
        animationDelay: '4s'
      }} />
        <div className="absolute bottom-20 right-10 w-28 h-28 bg-white/10 rounded-2xl backdrop-blur-sm -rotate-6 animate-float" style={{
        animationDelay: '1s'
      }} />
      </div>

      {/* Main content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen py-16 md:py-28">
        <div className="text-center px-4 max-w-6xl mx-auto">
          {/* Launch badge with glow effect */}
          <div className="inline-block mb-8 animate-slide-up">
            <div className="bg-white/20 backdrop-blur-md text-white font-medium px-6 py-3 rounded-full text-sm border border-white/30 shadow-2xl animate-pulse-glow">
              Launching soon
            </div>
          </div>
          
          {/* Main headline with 3D effect */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-8 animate-slide-up leading-tight" style={{
          animationDelay: '0.2s'
        }}>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-blue-100 drop-shadow-2xl">
              Solving Copyrightability for
            </span>
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-100 via-white to-white drop-shadow-2xl">
              AI-assisted music
            </span>
          </h1>
          
          {/* Subtitle with glass morphism */}
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 mb-12 border border-white/20 shadow-2xl animate-slide-up max-w-4xl mx-auto" style={{
          animationDelay: '0.4s'
        }}>
            <p className="text-white/95 text-xl md:text-2xl leading-relaxed">Our technology enables Intentional AI usage reporting &amp; provides measurement of human contribution in modern music production</p>
          </div>
          
          {/* CTA Buttons with modern styling */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 animate-slide-up" style={{
          animationDelay: '0.6s'
        }}>
            <Link 
              to="/join-waitlist"
              className="bg-white/15 backdrop-blur-md text-white px-8 py-4 rounded-full text-lg border border-white/30 shadow-xl hover:bg-white/25 transition-all duration-300 inline-block"
            >
              Join the Waitlist
            </Link>
            <Link 
              to="/ai-music-framework"
              className="group bg-white text-tagblue hover:bg-blue-50 transition-all duration-300 px-10 py-4 rounded-full font-semibold text-lg shadow-2xl hover:shadow-white/25 hover:scale-105 transform"
            >
              AI Music Framework
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default HeroSection;